import PropTypes from 'prop-types';

// mantine
import { ScrollArea } from '@mantine/core';

// project imports
import MenuList from './MenuList';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen }) => (
  <ScrollArea h="100%" type="auto" px="md" pt="md" styles={{ viewport: { overscrollBehavior: 'contain' } }}>
    <MenuList drawerOpen={drawerOpen} />
  </ScrollArea>
);

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool
};

export default Sidebar;
